import { getTermValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

export const geoBbox: ITagGroupConfig = {
  get({ jsonQuery }) {
    const bbox = getTermValue('bbox')(jsonQuery);
    if (!bbox) {
      return null;
    }

    // Сейчас bbox может быть только один, если их появится больше,
    // то нужно будет возвращать тег с полем data, чтобы можно было отличать
    // один bbox от другого по набору уникальных данных
    return [
      {
        group: 'geoBbox',
        text: 'Область поиска',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setBbox',
      arguments: [null],
    });
  },
};
